import Button from "../core/Button";

export default class TweenUtils {
	public static ButtonBounce(scene: Phaser.Scene, button: Button): () => void {
		const w = button.width;
		const h = button.height;
		if (button.originX != 0.5 || button.originY != 0.5) {
			button.x += (0.5 - button.originX) * w;
			button.y += (0.5 - button.originY) * h;
			button.setOrigin(0.5, 0.5);
		}

		const tween = scene.add.tween({
			targets: button,
			paused: true,
			duration: 50,
			yoyo: true,
			displayWidth: w * 0.9,
			displayHeight: h * 0.9,
			ease: "Quad.easeOut",
		});

		return (): void => {
			tween.play();
		};
	}

	public static ButtonBounceWithText(scene: Phaser.Scene, button: Button, text: Phaser.GameObjects.Text): () => void {
		const w = button.width;
		const h = button.height;
		if (button.originX != 0.5 || button.originY != 0.5) {
			button.x += (0.5 - button.originX) * w;
			button.y += (0.5 - button.originY) * h;
			button.setOrigin(0.5, 0.5);
		}

		const tween1 = scene.add.tween({
			targets: button,
			paused: true,
			duration: 50,
			yoyo: true,
			displayWidth: w * 0.9,
			displayHeight: h * 0.9,
			ease: "Quad.easeOut",
		});

		const tween2 = scene.add.tween({
			targets: text,
			paused: true,
			duration: 50,
			yoyo: true,
			displayWidth: text.width * 0.9,
			displayHeight: text.height * 0.9,
			ease: "Quad.easeOut",
		});

		return (): void => {
			tween1.play();
			tween2.play();
		};
	}

	public static BounceContainer(scene: Phaser.Scene, button: Phaser.GameObjects.Container): () => void {
		const tween = scene.add.tween({
			targets: button,
			duration: 50,
			yoyo: true,
			scale: button.scale * 0.9,
			ease: "Quad.easeOut",
		});

		return (): void => {
			tween.play();
		};
	}
}
